const loadingStore = {
    namespaced: true,
    state: {
        loadings: [],
    },
    actions: {
    },
    mutations: {
        push(state, {id, message}) {
            const loading = {id, message}
            state.loadings.push(loading);
        },
        remove(state, {id}) {
            state.loadings = state.loadings.filter(l => l.id !== id);
        }
    },
    getters: {
        loadings: state => state.loadings,
    }
}

export default loadingStore;
